/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RecoverImport } from './routes/recover'
import { Route as PlaygroundImport } from './routes/playground'
import { Route as LayoutImport } from './routes/_layout'
import { Route as LayoutIndexImport } from './routes/_layout.index'
import { Route as LayoutRecoveryImport } from './routes/_layout.recovery'
import { Route as LayoutAboutImport } from './routes/_layout.about'
import { Route as LayoutEmailVerifyImport } from './routes/_layout.email.verify'

// Create/Update Routes

const RecoverRoute = RecoverImport.update({
  id: '/recover',
  path: '/recover',
  getParentRoute: () => rootRoute,
} as any)

const PlaygroundRoute = PlaygroundImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutRecoveryRoute = LayoutRecoveryImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAboutRoute = LayoutAboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEmailVerifyRoute = LayoutEmailVerifyImport.update({
  id: '/email/verify',
  path: '/email/verify',
  getParentRoute: () => LayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundImport
      parentRoute: typeof rootRoute
    }
    '/recover': {
      id: '/recover'
      path: '/recover'
      fullPath: '/recover'
      preLoaderRoute: typeof RecoverImport
      parentRoute: typeof rootRoute
    }
    '/_layout/about': {
      id: '/_layout/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof LayoutAboutImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/recovery': {
      id: '/_layout/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof LayoutRecoveryImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/email/verify': {
      id: '/_layout/email/verify'
      path: '/email/verify'
      fullPath: '/email/verify'
      preLoaderRoute: typeof LayoutEmailVerifyImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutRouteChildren {
  LayoutAboutRoute: typeof LayoutAboutRoute
  LayoutRecoveryRoute: typeof LayoutRecoveryRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutEmailVerifyRoute: typeof LayoutEmailVerifyRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAboutRoute: LayoutAboutRoute,
  LayoutRecoveryRoute: LayoutRecoveryRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutEmailVerifyRoute: LayoutEmailVerifyRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof LayoutRouteWithChildren
  '/playground': typeof PlaygroundRoute
  '/recover': typeof RecoverRoute
  '/about': typeof LayoutAboutRoute
  '/recovery': typeof LayoutRecoveryRoute
  '/': typeof LayoutIndexRoute
  '/email/verify': typeof LayoutEmailVerifyRoute
}

export interface FileRoutesByTo {
  '/playground': typeof PlaygroundRoute
  '/recover': typeof RecoverRoute
  '/about': typeof LayoutAboutRoute
  '/recovery': typeof LayoutRecoveryRoute
  '/': typeof LayoutIndexRoute
  '/email/verify': typeof LayoutEmailVerifyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/playground': typeof PlaygroundRoute
  '/recover': typeof RecoverRoute
  '/_layout/about': typeof LayoutAboutRoute
  '/_layout/recovery': typeof LayoutRecoveryRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/email/verify': typeof LayoutEmailVerifyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/playground'
    | '/recover'
    | '/about'
    | '/recovery'
    | '/'
    | '/email/verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/playground'
    | '/recover'
    | '/about'
    | '/recovery'
    | '/'
    | '/email/verify'
  id:
    | '__root__'
    | '/_layout'
    | '/playground'
    | '/recover'
    | '/_layout/about'
    | '/_layout/recovery'
    | '/_layout/'
    | '/_layout/email/verify'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  PlaygroundRoute: typeof PlaygroundRoute
  RecoverRoute: typeof RecoverRoute
}

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  PlaygroundRoute: PlaygroundRoute,
  RecoverRoute: RecoverRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/playground",
        "/recover"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/about",
        "/_layout/recovery",
        "/_layout/",
        "/_layout/email/verify"
      ]
    },
    "/playground": {
      "filePath": "playground.tsx"
    },
    "/recover": {
      "filePath": "recover.tsx"
    },
    "/_layout/about": {
      "filePath": "_layout.about.tsx",
      "parent": "/_layout"
    },
    "/_layout/recovery": {
      "filePath": "_layout.recovery.tsx",
      "parent": "/_layout"
    },
    "/_layout/": {
      "filePath": "_layout.index.tsx",
      "parent": "/_layout"
    },
    "/_layout/email/verify": {
      "filePath": "_layout.email.verify.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
